// extracted by mini-css-extract-plugin
export default {"formContainer":"goal-editor_formContainer__si45h"};